import { render } from "./AlarmDetails.vue?vue&type=template&id=1ccb152e&ts=true"
import script from "./AlarmDetails.vue?vue&type=script&lang=ts"
export * from "./AlarmDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__